import { IconButton, Stack, Tooltip } from "@mui/material";
import React, { ChangeEvent } from "react";
import DeleteForeverRoundedIcon from "@mui/icons-material/DeleteForeverRounded";
import { Box } from "@mui/system";
import { getTranslation } from "common";
import { useTranslations } from "hooks";
import Checkbox from "@mui/material/Checkbox";
import { UserData } from "hooks/useUserDataKeys";
import Userfield from "./Userfield";
import type { FieldDefinition } from "model/CustomFields";
import type { AttachmentHost } from "components/custom-fields/attachmentField";
import { definitionForUserdata, valueForUserdata } from "components/custom-fields/userdata";

interface FieldsListItemProps {
  //correzione sul readonly
  readonly?: boolean;
  canManage: boolean;
  item: { key: string; value: UserData };
  selectedProcess: number | undefined;
  onDelete: () => void;
  onEdit: (key: string, value: unknown) => void;
  onChangeInCard: (
    e: ChangeEvent<HTMLInputElement>,
    newCheck: boolean,
    key: string
  ) => void;
  check: boolean;
  /** La definizione del contratto, per il renderer dei tipi. */
  definition?: FieldDefinition | null;
  fieldId?: string;
  /** Come caricare un allegato, dove si può: vedi `AttachmentHost`. */
  attachments?: AttachmentHost | null;
  /**
   * Valore **legacy**: si mostra e basta.
   *
   * Gli userdata fuori schema non si creano più; quelli che esistono restano
   * leggibili (card, monitor, filtri, scheda) senza poter essere modificati o
   * cancellati. La preferenza «in card» resta invece modificabile: è
   * presentazione, non contenuto.
   */
  valueReadOnly?: boolean;
}

const FieldsListItem: React.FC<FieldsListItemProps> = ({
  canManage,
  selectedProcess,
  onChangeInCard,
  definition = null,
  fieldId,
  attachments = null,
  check,
  item,
  onDelete,
  onEdit,
  readonly,
  valueReadOnly = false,
}) => {
  const translations = useTranslations();

  const buttons = [
    // {
    //   tooltip: getTranslation(translations, "generic.edit.caption"),
    //   onClick: onEdit,
    //   icon: EditRoundedIcon,
    // },
    {
      tooltip: getTranslation(translations, "generic.delete.caption"),
      onClick: onDelete,
      icon: DeleteForeverRoundedIcon,
    },
  ];

  // const value = getUserDataValue(item.value);

  return (
    <Stack
      direction="row"
      justifyContent={"start"}
      alignItems={"center"}

    >
      <Box maxWidth={"100%"} flex={1} minWidth={0} >
        <Userfield
          name={item.key}
          value={valueForUserdata(item.value)}
          type={item.value.type}
          onChange={(v) => onEdit(item.key, v)}
          readonly={readonly || valueReadOnly}
          definition={definition ?? definitionForUserdata(item.key, item.value)}
          fieldId={fieldId}
          attachments={attachments}
        />
      </Box>
      {canManage && (
        <Stack minWidth={0} flexShrink={1} justifyContent={"flex-end"} direction="row">
          {!valueReadOnly && buttons.map((button, idx) => (
            <Tooltip key={idx} title={button.tooltip}>
              <IconButton
                id={`button-${idx}`}
                disabled={readonly}
                onClick={button.onClick}
                sx={{
                  color: "rgba(84, 189, 193, 1)",
                  borderRadius: "6px",
                }}
              >
                <button.icon />
              </IconButton>
            </Tooltip>
          ))}
          <Box
          >
            <Tooltip
              title={getTranslation(
                translations,
                "generic.showingincard.caption"
              )}
            >
              <Checkbox
                id={`button-${item.key}`}
                disabled={readonly}
                edge="end"
                onChange={(e, newCheck) =>
                  onChangeInCard(e, newCheck, item.key)
                }
                checked={check}
                inputProps={{
                  "aria-label": `${getTranslation(translations, "generic.showingincard.caption")}: ${item.key}`,
                }}
              />
            </Tooltip>
          </Box>
        </Stack>
      )}
    </Stack>
  );
};

export default FieldsListItem;
